<ng-template #linkContent>
  <ng-content></ng-content>
</ng-template>

@if (routerLink !== undefined && routerLink !== null) {
  <a class="fdk-link" [attr.rel]="rel" [routerLink]="routerLink" [target]="target">
    <ng-container [ngTemplateOutlet]="linkContent"></ng-container>
  </a>
} @else {
  <a class="fdk-link" [attr.rel]="rel" [href]="href" [target]="target">
    <ng-container [ngTemplateOutlet]="linkContent"></ng-container>
  </a>
}
